import { createDucks } from '@8powers/core/redux';

const { reducer, saga, actions } = createDucks('team', {
  team: {
    endpoint: 'team',
    slices: ['list', 'detail', 'create', 'edit']
  },
  profile: {
    endpoint: 'profile',
    slices: ['combo']
  }
});

export { saga, actions };
export default reducer;
